import { useApolloClient } from '@apollo/client'
import { useUsuarioEdicaoQueryHandler } from './use-query-handler'
import {
  createInitialValues,
  createSchemaArray,
  createSubmitHandler
} from '../utils/form'
import { useMemo } from 'react'
import { useNavigate } from 'react-router'

export const useUsuarioEdicaoForm = () => {
  const client = useApolloClient()
  const navigate = useNavigate()
  const onClose = () => navigate('/usuarios')
  const {
    usuarioData,
    cargosByUsuarioData,
    infoUsuarioData,
    usuarioDominioData,
    salvarUsuario,
    tiposUsuarioDocumentoObrigatorio,
    tiposUsuarioInformarCargo,
    tiposUsuarioInformarGestao,
    tiposMap,
    id,
    allDataLoaded
  } = useUsuarioEdicaoQueryHandler()
  const { tipoAcessoMap } = tiposMap

  const { produtos, marcas, tiposUsuario } = usuarioDominioData ?? {}
  const cargos = cargosByUsuarioData?.cargos ?? []
  const { infoUsuario } = infoUsuarioData ?? {}

  const initialValues = useMemo(() => {
    return createInitialValues(
      usuarioData,
      produtos,
      marcas,
      tiposUsuario,
      cargos,
      infoUsuario
    )
  }, [usuarioData, cargosByUsuarioData, infoUsuarioData, usuarioDominioData])

  const schemaArray = createSchemaArray(
    produtos,
    client,
    tipoAcessoMap,
    tiposUsuarioDocumentoObrigatorio,
    tiposUsuarioInformarCargo,
    tiposUsuarioInformarGestao
  )

  const submitHandler = createSubmitHandler(
    salvarUsuario,
    tiposUsuarioInformarGestao,
    onClose
  )

  return {
    initialValues,
    schemaArray,
    submitHandler,
    allDataLoaded,
    id,
    onClose
  }
}
